import { render } from "./report-icon.svg?vue&type=template&id=74f39acb"
import script from "./report-icon.svg?vue&type=script&lang=js"
export * from "./report-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src4146/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__